<as-split class="listing" direction="horizontal" [gutterSize]="18">
    <as-split-area [size]="20">
        <h3 class="header-title">Groups</h3>
        <div class="dataset-listing-tree">
            <div *ngFor="let group of potentialGroups" class="tree-node"
                (click)="selectGroup(group.id)" [ngClass]="{'selected': selectedGroup === group.id}">
                <div class="set-title">
                <button mat-icon-button>
                    <mat-icon svgIcon="account-group-outline"></mat-icon>
                </button>
                <span class="name">
                    {{ group.name }}
                </span>
                </div>
            </div>
        </div>
    </as-split-area>

    <as-split-area [size]="80">
      <ng-container *ngIf="selectedGroup">
        <mat-toolbar class="editing-toolbar">
            <span>Filter</span>

            <span class="spacer"></span>

            <button mat-raised-button class="tools-button" (click)="exportData()" [disabled]="exportButtonDisabled">
              <mat-icon svgIcon="content-save"></mat-icon>&nbsp;
              <span>Export</span>
            </button>
        </mat-toolbar>

        <div>
            <form [formGroup]="exportForm" class="input-form">
                <mat-label>Export type:</mat-label>
                <mat-radio-group formControlName="export_type">
                    <mat-radio-button *ngFor="let option of exportOptions" [value]="option.value">
                        {{ option.value }}
                    </mat-radio-button>
                </mat-radio-group>


                <mat-checkbox formControlName="photos_included">Photos included</mat-checkbox>

                <div class="padding-right" *ngIf="ExportTypeControl?.value == 'Filtered data'">
                    <mat-label>Filter by location:</mat-label>
                    <mat-radio-group formControlName="filter_type">
                        <mat-radio-button *ngFor="let option of filterOptions" [value]="option.value">
                        {{ option.value }}
                        </mat-radio-button>
                    </mat-radio-group>

                    <div class="padding-right" *ngIf="FilterTypeControl?.value == 'Full name'">
                        <div>
                            <mat-form-field>
                                <mat-label>Location name</mat-label>
                                <mat-select formControlName="location_names" (selectionChange)="locationChangeSelected($event)" multiple>
                                    <mat-option *ngFor="let location of potentialLocations" [value]="location.name">
                                        {{ location.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div>
                            <mat-form-field>
                                <mat-label>Trap name</mat-label>
                                <mat-select formControlName="trap_names" multiple>
                                    <!-- <mat-option value="">All traps</mat-option> -->
                                    <mat-option *ngFor="let trap of potentialTraps" [value]="trap.traptype">
                                        {{ trap.traptype }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="padding-right" *ngIf="FilterTypeControl?.value == 'Partial name'">
                        <div>
                            <mat-form-field>
                                <mat-label>Name</mat-label>
                                <input matInput formControlName="keyword_name">
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-label>Condition</mat-label>
                            <mat-radio-group formControlName="keyword_name_condition">
                                <mat-radio-button *ngFor="let option of conditionOptions" [value]="option.value">
                                {{ option.value }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
            </form>
        </div>
      </ng-container>
    </as-split-area>
</as-split>
